import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { asChakraVariable } from '@mangovoice/design-system'

const feedbackToastStyleParts = [
  'container',
  'header',
  'message',
  'button',
] as const

const helpers = createMultiStyleConfigHelpers(feedbackToastStyleParts)

export const FeedbackToastStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      border: '1px solid',
      borderColor: 'border.muted',
      borderRadius: '0.5rem',
      gap: '0.75rem',
      padding: '0.75rem',
      boxShadow: asChakraVariable({ default: 'shadows.subtle' }),
      backgroundColor: 'bg.default',
      flexDirection: 'column',
    },
    header: {
      fontWeight: '700',
      fontSize: '0.75rem',
      color: 'fg.default',
      alignItems: 'center',
    },
    message: {
      justifyContent: 'center',
      fontWeight: '400',
      fontSize: '1rem',
      color: 'fg.default',
      gap: '0.333rem',
    },
  },
})

export const useFeedbackToastStyle = () =>
  mergeMultiStyleConfig(FeedbackToastStyle) as MultiStyleType<
    typeof feedbackToastStyleParts
  >
